<template>
  <div class="create-reserve-view">
    <Navbar v-if="!isDesktop" />
    <NavbarDesktop 
      @onConfirmAction="onNavbarConfirmAction"
      @onDiscardAction="onNavbarDiscardAction"
      :action="navbarAction"
      :canCreatePreorder="true"
      :canStartOrderCreation="stage == 'details' ? are_details_ready : true"
      v-else />

    <div class="create-reserve-content">
      <PreorderCreationDetails
        :value="details"
        :mode="'reserve'"
        @input="(v) => (details = v)"
        @ready="(v) => (are_details_ready = v)"
        v-if="stage == 'details'"
      />

      <ReservationCard
        class="reservation-block"
        :reservation="fakeReservation"
        v-if="stage == 'check'"
      />
    </div>

    <div class="create-reserve-navbar" v-if="stage == 'details' && !isDesktop">
      <img src="/icons/btn-back.svg" @click="returnToOrders" class="btn-back" />

      <small class="info" v-if="!are_details_ready">
        {{ $t("create_preorder.fill_fields") }}
      </small>
      <div v-else class="w-80">
        <QueueButton
          class="create-action-button"
          variant="accept"
          @click="stage = 'check'"
        >
          {{ $t("create_preorder.to_order") }}
        </QueueButton>
      </div>
    </div>

    <div class="create-reserve-navbar" v-if="stage == 'check' && !isDesktop">
      <img
        src="/icons/btn-back.svg"
        @click="stage = 'details'"
        class="btn-back"
      />

      <QueueButton
        class="create-action-button w-80"
        variant="accept"
        @click="createReservation"
      >
        {{ $t("create_preorder.create_btn") }}
      </QueueButton>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

import PreorderCreationDetails from "@/components/details/PreorderCreationDetails.vue";

import moment from "moment";

import QueueButton from "@/components/QueueButton.vue";

import QueueAPI from "@/api/queue";

import ReservationCard from "@/components/notifications/ReservationCard.vue";

export default {
  data() {
    return {
      are_details_ready: false,

      details: null,

      stage: "details",
    };
  },
  components: {
    Navbar,
    NavbarDesktop,
    PreorderCreationDetails,
    QueueButton,
    ReservationCard,
  },
  methods: {
    returnToOrders() {
      this.$router.push("/orders?m=reserve");
    },
    createReservation() {
      QueueAPI.createReservation({
        name: this.details.name,
        phone: this.details.phone,
        reserve_date: this.details.takeaway_date,
        guests_count: this.details.guests_count,
        comment: this.details.comment,
      })
        .then((data) => {
          this.returnToOrders();
        })
        .catch((err) => {
          this.$store.commit("setError", err);
        });
    },
    onNavbarDiscardAction() {
      if (this.stage == 'details') {
        this.returnToOrders();
      } else {
        this.stage = 'details';
      }
    },
    onNavbarConfirmAction() {
      if (this.stage == 'details') {
        this.stage = 'check';
      } else {
        this.createReservation();
      }
    }
  },
  mounted() {

    if (!this.$store.state.initialized) {
      this.$store.dispatch("init");
    }
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    fakeReservation() {
      return {
        name: this.details.name,
        phone: this.details.phone,
        reserve_date: this.details.takeaway_date,
        guests_count: this.details.guests_count,
      };
    },
    navbarAction() {
      if (this.stage == "details") {
        return {
          type: "goto_order",
        };
      }

      if (this.stage == 'check') {
        return {
          type: 'create-preorder'
        }
      }
    },
  },
};
</script>

<style scoped>
.w-80 {
  width: 80% !important;
}

.create-reserve-navbar {
  background: #1d1d1d;
  bottom: 0;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  width: 100%;
  position: fixed;
  left: 0;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  margin: 0 -0.5vh auto;
  display: block;
}

.create-action-button {
  width: 100%;
}

.create-reserve-content {
  position: relative;
  overflow-x: hidden;
  margin-bottom: 14vh;
}

.preorder-card-block {
  margin-bottom: 32vh;
}

.reservation-block {
  /* margin-top: 4vh; */
  padding-top: 10vh;
}

@media screen and (min-width: 768px) {
  .create-reserve-content {
  margin-top: 9vh;
}

}
</style>